import React from "react";
import { format } from "date-fns";
import { Tooltip } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { UI_ICONS } from "../../layout/menuIcons";
import { useMutes } from "../../context/Mutes/MutesContext";

const MutedIcon = ({ contactId, className, style }) => {
  const { mutedUntil } = useMutes();
  const until = mutedUntil(contactId);
  if (until === undefined) return null;
  const Icon = UI_ICONS.muted;
  const title = until
    ? i18n.t("mutes.tooltipUntil", { date: format(until, "dd/MM HH:mm") })
    : i18n.t("mutes.tooltip");
  return (
    <Tooltip title={title}>
      <span
        className={className}
        style={{ display: "inline-flex", alignItems: "center", flex: "none", ...style }}
        data-testid="muted-icon"
      >
        <Icon aria-label={title} />
      </span>
    </Tooltip>
  );
};

export default MutedIcon;
